import { render } from "./video_attachment.vue?vue&type=template&id=dda2841a"
import script from "./video_attachment.js?vue&type=script&lang=js"
export * from "./video_attachment.js?vue&type=script&lang=js"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__